import React, { useState } from "react";
import { DreamTeamRow } from "./DreamTeamRow";
import { SimpleDropdown } from "../../../../../components/common/SimpleDropdown";

const STATE_OPTIONS = [
  { value: 'all', label: 'All States' },
  { value: 'AL', label: 'Alabama' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
];

const REGION_OPTIONS = [
  { value: 'all', label: 'All Regions' },
  { value: 'northeast', label: 'Northeast' },
  { value: 'southeast', label: 'Southeast' },
  { value: 'midwest', label: 'Midwest' },
  { value: 'southwest', label: 'Southwest' },
  { value: 'west', label: 'West' },
];

export const DreamTeamTable = ({
  teams,
  title = "DREAM TEAM",
  searchValue = '',
  onSearchChange,
  loading = false,
  pagination,
  onLoadMore,
  showSearch = false
}) => {
  const [selectedState, setSelectedState] = useState('all');
  const [selectedRegion, setSelectedRegion] = useState('all');

  return (
    <>
      {showSearch && (
        <div className="flex items-center gap-3 mb-3">
          <input
            placeholder="Find team"
            value={searchValue}
            onChange={(e) => onSearchChange?.(e.target.value)}
            className="flex-1 h-9 px-3 rounded-lg bg-slate-800 text-xs text-white border border-slate-600 focus:outline-none"
          />
          <div className="w-32">
            <SimpleDropdown
              value={selectedState}
              onChange={setSelectedState}
              options={STATE_OPTIONS}
              placeholder="State"
              variant="form"
            />
          </div>
          <div className="w-32">
            <SimpleDropdown
              value={selectedRegion}
              onChange={setSelectedRegion}
              options={REGION_OPTIONS}
              placeholder="Region"
              variant="form"
            />
          </div>
        </div>
      )}

    <div className="flex items-center justify-between mb-2">
      <h3 className="text-xs font-semibold text-white">{title}</h3>
      {pagination && (
        <span className="text-[10px] text-slate-400">
          Showing {teams.length} of {pagination.totalTeams} teams
        </span>
      )}
    </div>

    <div className="overflow-y-auto rounded-2xl bg-slate-900/60 custom-scrollbar" style={{ maxHeight: '400px', minHeight: '200px' }}>
      <table className="w-full text-[10px] border-collapse">
        <thead className="bg-slate-900/80 text-slate-200 sticky top-0 z-10">
          <tr>
            <th className="px-1 py-1.5 text-center text-[9px]">LOGO</th>
            <th className="px-2 py-1.5 text-center text-[9px]">TEAM</th>
            <th className="px-1 py-1.5 text-center text-[9px]">OVR</th>
            <th className="px-1 py-1.5 text-center text-[9px]">HOME</th>
            <th className="px-1 py-1.5 text-center text-[9px]">AWAY</th>
            <th className="px-1 py-1.5 text-center text-[9px]">NEUT</th>
            <th className="px-1 py-1.5 text-center text-[9px]">CONF</th>
            <th className="px-1 py-1.5 text-center text-[9px]"></th>
          </tr>
        </thead>
        <tbody>
          {teams.map((t) => (
            <DreamTeamRow key={t.id} team={t} />
          ))}
          {loading && (
            <tr>
              <td colSpan="8" className="text-center py-4">
                <div className="flex items-center justify-center">
                  <div className="w-5 h-5 border-2 border-cyan-500 border-t-transparent rounded-full animate-spin"></div>
                </div>
              </td>
            </tr>
          )}
          {!loading && teams.length === 0 && (
            <tr>
              <td colSpan="8" className="text-center py-4 text-slate-400 text-xs">
                No teams found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>

      {pagination?.hasMore && !loading && (
        <div className="flex justify-center mt-3">
          <button
            onClick={onLoadMore}
            className="px-4 py-1.5 text-xs bg-cyan-600 hover:bg-cyan-700 text-white rounded-lg transition-colors"
          >
            Load More
          </button>
        </div>
      )}
    </>
  );
};
